import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select, { components } from 'react-select';

const Option = (props) => (
  <div>
    <components.Option {...props}>
      <div>
        <img src={props.data.image} height="30px" width="30px" />
        &nbsp;
        {props.data.label}
      </div>
    </components.Option>
  </div>
);

const ValueContainer = ({ children, getValue, ...props }) => {
  const value = getValue();
  return (
    <components.ValueContainer {...props}>
      {!props.selectProps.inputValue && value.length > 0 && (
        <div>
          <img src={value[0].image} height="30px" width="30px" />
          &nbsp;
          {value[0].label}
        </div>
      )}
      {React.Children.map(children, (child) => {
        return child && child.type === components.Input ? child : null;
      })}
    </components.ValueContainer>
  );
};

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <i className="fa fa-caret-down" />
    </components.DropdownIndicator>
  );
};

class ImageSelect extends Component {
  static propTypes = {
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.node,
        label: PropTypes.node,
      }),
    ).isRequired,
    onChangeCallback: PropTypes.func.isRequired,
  };

  static defaultProps = {
    options: [],
  };

  render() {
    const { options, isMulti, onChangeCallback, value, ...otherProps } = this.props;
    return <Select getOptionLabel={(opt) => opt.label} getOptionValue={(opt) => opt.value} closeMenuOnSelect={true} classNamePrefix="ui-select" isMulti={isMulti} components={{ Option, ValueContainer, DropdownIndicator }} value={value} options={options} hideSelectedOptions={false} backspaceRemovesValue={false} onChange={(e) => onChangeCallback(e)} {...otherProps} />;
  }
}

export default ImageSelect;
